/* eslint-disable jsx-a11y/anchor-is-valid */
import cn from 'classnames';

import CommonStyles from 'styles/common.module.css';

interface Props {
  appInfo: {
    api_status: boolean;
    api_message: string;
    api_period: string;
  };
}

/**
 * @description Parking F.C
 * @Class
 * @category Pages
 * @subcategory default
 * @component
 * @returns {JSX.Element}
 */
const Parking = (props: Props): JSX.Element => {
  const { appInfo } = props;
  console.log('appInfo in Parking', appInfo);
  return (
    <div id="wrap">
      <div className={cn(CommonStyles.header, CommonStyles['logout-header'])}>
        <div className={CommonStyles['header-left']}>
          <button type="button" className={CommonStyles.logo}>
            <span className={CommonStyles.a11y_hidden}>이실장넷</span>
          </button>
        </div>
      </div>

      <div className={cn(CommonStyles.container, CommonStyles.parking)}>
        <div className={CommonStyles.content}>
          <i className={CommonStyles['icon-parking']} />
          <h1 className={CommonStyles.tit}>이실장넷은 2026년 10월 31일부로 종료되었습니다.​</h1>
          <h2 className={CommonStyles.txt}>
          그동안 이실장넷을 이용해 주셔서 감사합니다.​
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Parking;
